import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getClients as getClientsApi,
  addNewClient as addNewClientApi,
  updateClient as updateClientApi,
  deleteClient as deleteClientApi,
  getClientById as getClientByIdApi,
  getClientDetails as getClientDetailsApi,
  getAvailableContacts as getAvailableContactsApi,
  getClientUnitsById as getClientUnitsByIdApi,
  getClientsOverdue as getClientsOverdueApi,
} from "../../helpers/fakebackend_helper";

// Fetch Clients
export const getClients = createAsyncThunk("clients", async (queryParams) => {
  try {
    const response = await getClientsApi(queryParams);
    return response;
  } catch (error) {
    toast.error("Failed to fetch clients", { autoClose: 3000 });
    throw error;
  }
});

export const getClientsOverdue = createAsyncThunk(
  "clientsOverdue",
  async () => {
    try {
      const response = await getClientsOverdueApi();
      return response;
    } catch (error) {
      toast.error("Failed to fetch clients", { autoClose: 3000 });
      throw error;
    }
  }
);

// Fetch Client by ID
export const getClientById = createAsyncThunk(
  "clients/getClientById",
  async (id) => {
    try {
      const response = await getClientByIdApi(id);
      return response;
    } catch (error) {
      toast.error("Failed to fetch client by ID", { autoClose: 3000 });
      throw error;
    }
  }
);
// Fetch Client Details by ID
export const getClientDetails = createAsyncThunk(
  "clients/getClientDetails",
  async (id) => {
    try {
      const response = await getClientDetailsApi(id);
      return response;
    } catch (error) {
      toast.error("Failed to fetch client details", { autoClose: 3000 });
      throw error;
    }
  }
);
// Fetch Available Contacts
export const getAvailableContacts = createAsyncThunk(
  "clients/getAvailableContacts",
  async (id) => {
    try {
      const response = await getAvailableContactsApi(id);
      return response;
    } catch (error) {
      toast.error("Failed to fetch available contacts", { autoClose: 3000 });
      throw error;
    }
  }
);

// Fetch Client Units by ID
export const getClientUnits = createAsyncThunk(
  "clients/getClientUnits",
  async (id) => {
    try {
      const response = await getClientUnitsByIdApi(id);
      return response;
    } catch (error) {
      toast.error("Failed to fetch client by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

// Add New Client
export const addNewClient = createAsyncThunk(
  "clients/addNewClient",
  async (client) => {
    try {
      const response = await addNewClientApi(client);
      toast.success("Client Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to add client", { autoClose: 3000 });
      throw error;
    }
  }
);

// Update Client
export const updateClient = createAsyncThunk(
  "clients/updateClient",
  async (client) => {
    try {
      const response = await updateClientApi(client);
      toast.success("Client Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to update client", { autoClose: 3000 });
      throw error;
    }
  }
);

// Delete Client
export const deleteClient = createAsyncThunk(
  "clients/deleteClient",
  async (clientId) => {
    try {
      const response = await deleteClientApi(clientId);
      toast.success("Client Deleted Successfully", { autoClose: 3000 });
      return { clientId, ...response };
    } catch (error) {
      toast.error("Failed to delete client", { autoClose: 3000 });
      throw error;
    }
  }
);

